import { Box, Typography } from "@jewlr/storybook/core"
import { FloatSelect } from "@jewlr/storybook/form"
import PropTypes from "prop-types"
import { useState, useEffect } from "react"
import { useSearchParams } from "react-router-dom"

import {
  FormContainer,
  FormWrapper,
  Text,
  SubmitButton,
  CancelButton,
  InputWrapper,
  ImgWrapper,
  OrderNumber,
  ProductContainer,
  ProductImg,
  ProductTitle,
} from "../components"
import Heading from "../heading"

import { createMarkup } from "./components"

const SelectItemForm = ({ orderData, orderNumber, canSubmit }) => {
  const [currentId, setCurrentId] = useState(
    Object.keys(orderData.line_items)[0]
  )
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const lii = searchParams.get("lii")
    if (lii) {
      setCurrentId(lii)
    }
  }, [location])

  let item = orderData.line_items[currentId]

  return (
    <FormContainer>
      <Heading rmaType="change-order" />
      <form action={orderData.line_items[currentId]?.edit_link} method="post">
        <Typography fontSize="18px" fontWeight="500" lineHeight="20px">
          Your Order Number:
        </Typography>
        <OrderNumber>{orderNumber}</OrderNumber>
        <input name="order_number" readOnly type="hidden" value={orderNumber} />
        <input
          name="order_currency_code"
          readOnly
          type="hidden"
          value={item?.edit_params.currency_code || ""}
        />
        <input
          id="oparams"
          name="oparams"
          readOnly
          type="hidden"
          value={item?.edit_params.oparams || ""}
        />

        <InputWrapper>
          <FloatSelect
            id="rma_id"
            label="Choose the product you wish to change"
            onChange={(e) => setCurrentId(e.target.value)}
            value={currentId}
          >
            <option disabled value="">
              Choose item
            </option>
            {Object.keys(orderData.line_items).map((key, i) => {
              return (
                <option key={i} value={key}>
                  {orderData.line_items[key].title}
                </option>
              )
            })}
          </FloatSelect>
        </InputWrapper>

        {item && (
          <>
            <ProductContainer alignItems="flex-start">
              <ImgWrapper>
                <ProductImg alt={item?.title} src={item?.url} />
              </ImgWrapper>
              <Box textAlign="left">
                <ProductTitle mb={3}>{item.title}</ProductTitle>
                <Text fontWeight="500" mb="4px">
                  Item Details:
                </Text>

                {item.details !== undefined &&
                  item.details.map((desc, i) => {
                    return (
                      <Text
                        dangerouslySetInnerHTML={createMarkup(desc)}
                        key={i}
                        mb="4px"
                      />
                    )
                  })}
              </Box>
            </ProductContainer>
            <FormWrapper>
              <Text>
                When you select &quot;Continue&quot;, you will proceed to our
                website to make changes to your order. Do not navigate anywhere
                else on the website. When you are finished with your changes,
                click &quot;Update Order&quot; to proceed to confirmation and
                payment if necessary.
              </Text>
              <br />
              <Text fontWeight="400">
                Your change request may delay your order depending on where in
                the manufacturing process your order is in when you make the
                request.
              </Text>
              <br />
              <Text mb={5}>
                Once your request is processed, you will receive a new
                confirmation email with your changes and updated shipping time.
                Please review this email to ensure your details are correct.
              </Text>
            </FormWrapper>
          </>
        )}
        <InputWrapper>
          <SubmitButton
            data-cy="order-actions-select-item-continue-btn"
            disabled={!currentId}
          >
            {canSubmit ? "Continue" : "Continue..."}
          </SubmitButton>
        </InputWrapper>
        <InputWrapper>
          <CancelButton data-lc="select-item-form" to="/">
            Cancel and Continue Shopping
          </CancelButton>
        </InputWrapper>
      </form>
    </FormContainer>
  )
}

SelectItemForm.propTypes = {
  canSubmit: PropTypes.bool,
  currentId: PropTypes.string,
  item: PropTypes.object,
  orderData: PropTypes.object,
  orderNumber: PropTypes.string,
  setCurrentId: PropTypes.func,
}

export default SelectItemForm
